import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-overflow-x-auto tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur" }
const _hoisted_2 = { class: "tw-min-w-full tw-border-separate tw-border-spacing-0 tw-text-left" }
const _hoisted_3 = { class: "tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }
const _hoisted_4 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_6 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_7 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_8 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_9 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_10 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_13 = { class: "tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_14 = { class: "tw-px-3 tw-py-3 tw-text-sm" }
const _hoisted_15 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_16 = {
  key: 0,
  class: "tw-font-medium"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "tw-text-slate-400"
}
const _hoisted_19 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "tw-text-slate-400"
}
const _hoisted_22 = { class: "tw-px-3 tw-py-3 tw-text-sm" }
const _hoisted_23 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-900"
}
const _hoisted_24 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-rose-100 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-rose-900"
}
const _hoisted_25 = {
  key: 2,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-emerald-900"
}
const _hoisted_26 = {
  key: 3,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-red-400 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_27 = {
  key: 4,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-slate-100 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-slate-800"
}
const _hoisted_28 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_29 = {
  key: 0,
  class: "tw-font-mono tw-text-xs"
}
const _hoisted_30 = {
  key: 1,
  class: "tw-font-mono tw-text-xs"
}
const _hoisted_31 = {
  key: 2,
  class: "tw-text-slate-400"
}
const _hoisted_32 = { class: "tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_33 = { class: "tw-flex tw-items-center tw-gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CopyButton = _resolveComponent("CopyButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("th", {
            class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSortBy('orderId')))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Order", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'orderId' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                class: _normalizeClass(["tw-h-3 tw-w-3 tw-transition-transform", _ctx.sortBy === 'orderId' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", {
            class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSortBy('createdOn')))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Created", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'createdOn' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'createdOn' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Type", -1)),
          _createElementVNode("th", {
            class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSortBy('receiver')))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "Receiver", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'receiver' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'receiver' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", {
            class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSortBy('billing')))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "Bill To", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'billing' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'billing' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", {
            class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSortBy('status')))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("span", null, "Status", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'status' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'status' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _createElementVNode("th", {
            class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSortBy('bl')))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "BL", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.sortBy === 'bl' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'bl' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
              }, null, 8, ["icon", "class"])
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-z-10 tw-bg-slate-50/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Containers", -1))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order, orderIdx) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: order.id || orderIdx,
            class: _normalizeClass(["order-item-row tw-cursor-pointer tw-transition-colors", [
            _ctx.getIsLastOpenedListItem(_ctx.lastOpenedOrderId, order.id)
              ? 'tw-bg-amber-100/70'
              : (Number(orderIdx) % 2 === 0 ? 'tw-bg-white/40' : 'tw-bg-slate-50/40'),
            'hover:tw-bg-indigo-50/80',
          ]]),
            onClick: ($event: any) => (_ctx.selectOrder(order.id))
          }, [
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_CopyButton, {
                value: String(order.id),
                mode: "wrap-content",
                title: "Copy order ID",
                "aria-label": "Copy order ID to clipboard"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(order.id), 1)
                ]),
                _: 2
              }, 1032, ["value"])
            ]),
            _createElementVNode("td", _hoisted_13, _toDisplayString(order.createdAt), 1),
            _createElementVNode("td", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold", _ctx.isOceanExport(order)
                ? 'tw-bg-amber-100 tw-text-amber-900'
                : (_ctx.isOceanImport(order) || _ctx.isDropPick(order))
                  ? 'tw-bg-sky-100 tw-text-sky-900'
                  : _ctx.isLandOrder(order)
                    ? 'tw-bg-emerald-100 tw-text-emerald-900'
                    : 'tw-bg-slate-100 tw-text-slate-700'])
              }, _toDisplayString(order.orderType), 3)
            ]),
            _createElementVNode("td", _hoisted_15, [
              (order.customer)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(order.customer.name), 1))
                : (order.receiver)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(order.receiver.name), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, "—"))
            ]),
            _createElementVNode("td", _hoisted_19, [
              (order.billTo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(order.billTo.name), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
            ]),
            _createElementVNode("td", _hoisted_22, [
              (!order.status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Unknown "))
                : (order.status === 'Not Available')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Not Available "))
                  : (order.status === 'In Progress')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(order.status), 1))
                    : (order.status === 'Cancelled')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(order.status), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(order.status), 1))
            ]),
            _createElementVNode("td", _hoisted_28, [
              (order.isExport)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _createVNode(_component_CopyButton, {
                      value: order.bookingNumber,
                      mode: "wrap-content",
                      title: "Copy booking number",
                      "aria-label": "Copy booking number to clipboard"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.bookingNumber), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]))
                : (order.billOfLading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                      _createVNode(_component_CopyButton, {
                        value: order.billOfLading.billOfLadingId,
                        mode: "wrap-content",
                        title: "Copy B/L ID",
                        "aria-label": "Copy B/L ID to clipboard"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.billOfLading.billOfLadingId), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_31, "N/A"))
            ]),
            _createElementVNode("td", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "box",
                  class: "tw-text-slate-400 tw-h-3"
                }),
                _createTextVNode(" " + _toDisplayString(order.containers ? order.containers.length : 0), 1)
              ])
            ])
          ], 10, _hoisted_11))
        }), 128))
      ])
    ])
  ]))
}